import type {
    APIInstanceParams,
    APIPacket,
    CallbackMessage,
    CallbackMessageWithResponse,
    CallbackResponseMessage,
    RequestMessage,
} from '@bpinc/adapters-public-api-types'
import {callbackMessages, callbackResponseMessages, requestMessages} from '@bpinc/adapters-public-api-types'
import {array, isObject, typedKeys} from '@bpinc/lib-types-helpers'


export function isValidAPIPacket(data: unknown): data is APIPacket {
    return (
        !!data && isObject(data) &&
        'type' in data && typeof data.type === 'string' &&
        'instanceId' in data && typeof data.instanceId === 'string' &&
        'uid' in data && typeof data.uid === 'string' &&
        'params' in data && data.params instanceof Array
    )
}

export function isAPIInstanceParams(data: unknown): data is APIInstanceParams {
    return (
        !!data && isObject(data) &&
        'integrationKey' in data && typeof data.integrationKey === 'string' &&
        'instanceId' in data && typeof data.instanceId === 'string' &&
        'urlParams' in data && typeof data.urlParams === 'string' &&
        'disableNewInteractionPopup' in data && typeof data.disableNewInteractionPopup === 'boolean' &&
        'adaptiveWidth' in data && typeof data.adaptiveWidth === 'boolean'
    )
}

export function isCallbackMessage(type: string): type is CallbackMessage {
    return array(typedKeys(callbackMessages)).includes(type)
}

export function isRequestMessage(type: string): type is RequestMessage {
    return array(requestMessages).includes(type)
}
export function assertRequestMessage(type: string): asserts type is RequestMessage {
    if (!isRequestMessage(type)) {
        throw Error(`assertRequestMessage failed for "${type}"`)
    }
}

export function isCallbackResponseMessage(type: string): type is CallbackResponseMessage {
    return array(callbackResponseMessages).includes(type)
}

export function assertHtmlIframeElement(element: HTMLElement | null): asserts element is HTMLIFrameElement {
    if (!element || !(element instanceof HTMLIFrameElement)) {
        throw Error('assertHtmlIframeElement failed')
    }
}

export function isCallbackMessageWithResponse(type: string): type is CallbackMessageWithResponse {
    return isCallbackMessage(type) && callbackMessages[type].needResponse
}
